import fetchExpresso from 'utility/fetchExpresso';

export const mcpQueryKey = ['admin', 'mcp'];

export async function mcpRequest(path = '', method = 'GET', body) {
    const response = await fetchExpresso(`/admin/mcp${path}`, { method, body });
    if (response.status === 204) return null;
    const data = await response.json().catch(() => null);
    if (!response.ok) {
        throw new Error(data?.message || 'Unable to load AI connections. Please try again.');
    }
    return data;
}

export function connectionStatus(connection, enabled, now = Date.now()) {
    if (connection.revoked_at) return 'Revoked';
    if (Number(connection.expires_at) <= now) return 'Expired';
    return enabled ? 'Active' : 'Paused';
}
